@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.expectationsSwitcherRoot {
  @include typography-v2-body-base;
  @include border-radius-r2;
  display: flex;
  align-items: center;
  color: var(--text-primary);
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 12px;
}

.customButtonGroup {
  width: 200px;
}
